import React, { Component, createRef } from 'react'
import { Alert, Icon, Input, Tabs } from "antd"
import PropTypes from 'prop-types'

const { TabPane } = Tabs
class InputBarcode extends Component {
    state = {
        error: '',
        factory: '1C'
    }

    _input = createRef()

    _handleSubmit = (e) => {
        e.preventDefault()

        this.setState({
            error: ''
        })

        const { value, onSubmit } = this.props

        if (!value || !value.trim()) return false

        // const regex = /^#([1-9][0-9]{5,})(_[0-9]+)/
        const check = /^#\d+_\d+$/.test(value)

        if (!check) {
            const { onClose } = this.props

            onClose(() => {
                this._input.current.focus()
            })

            return this.setState({
                error: 'Định dạng barcode không đúng vui lòng kiểm tra lại'
            })
        }

        if (typeof onSubmit === 'function') {
            onSubmit(value, this.state.factory)
        }
    }

    _handleOnChange = e => {
        const { value } = e.target
        const { onChange } = this.props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    _handleClear = e => {
        e.preventDefault()

        const { onClose } = this.props
        onClose(() => {
            this._input.current.focus()
        })
    }

    callback = (key) => {
        this.setState({factory: key})
    }

    render() {
        const { value, loading, data = {} } = this.props
        const { error, factory = '1C' } = this.state

        return (
            <div className="InputBarcode">
                <div className='bg-light p-3 mb-3'>
                    <Tabs onChange={this.callback} type="card" activeKey={factory}>
                        <TabPane tab="Bình Minh" key="1C">
                            <h1>Nhập mã đơn Bình Minh</h1>
                        </TabPane>
                        <TabPane tab="Toàn Cầu" key="TCVN">
                            <h1>Nhập mã đơn Toàn Cầu</h1>
                        </TabPane>
                        <TabPane tab="Lab" key="MCVN">
                            <h1>Nhập mã đơn Lab</h1>
                        </TabPane>
                    </Tabs>

                    <form onSubmit={this._handleSubmit} className='mb-3'>
                        <div className='position-relative'>
                            <Input size='large' autoFocus
                                readOnly={loading}
                                value={value}
                                ref={this._input}
                                onChange={this._handleOnChange}
                                className='InputSearch' />

                            <div onClick={this._handleClear} className='position-absolute IconClear'>
                                <Icon type="close-circle" theme="filled" />
                            </div>
                        </div>

                        {
                            error && <Alert message={error} type='error' className='mt-3' />
                        }
                    </form>
                </div>
            </div>
        )
    }
}

InputBarcode.propTypes = {
    value: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default InputBarcode